(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ModerationCompanyController', ModerationCompanyController);

    ModerationCompanyController.$inject = ['Principal', 'ModerationOrganisation', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function ModerationCompanyController(Principal, ModerationOrganisation, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

       
        vm.currentAccount = null;
        vm.loadAll = loadAll;
        vm.moderationCompanies = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.directApprove = directApprove;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function loadAll () {
            ModerationOrganisation.queryCompany({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.moderationCompanies = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }
        
        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function directApprove (moderationCompany) {
            if (moderationCompany.moderationType == "CREATE") {
                vm.isSaving = true;
                ModerationOrganisation.directCreateAndApprove(moderationCompany, onSaveSuccess, onSaveError);
            } else if (moderationCompany.moderationType == "UPDATE") {
                vm.isSaving = true;
                ModerationOrganisation.directUpdateAndApprove(moderationCompany, onSaveSuccess, onSaveError);
            } else {
                console.log("Wrong moderation type. Must be CREATE or UPDATE")
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            vm.loadAll();
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();
